const RecurringItemsView = ({ data, currencySymbol }) => {
  console.log("data", data);
  return (
    <div className="-mx-2 text-sm">
      <table className="font-code whitespace-nowrap">
        <thead>
          <tr>
            <th>Date</th>
            <th>Name</th>
            <th className="w-full">Remark</th>
            <th className="text-right">Amount</th>
          </tr>
        </thead>
        <tbody>
          {data.map((i, index) => (
            <tr key={index} className="border-y dark:border-gray-700">
              <td>{i.date}</td>
              <td>{i.name}</td>
              <td className="whitespace-pre-wrap">{i.remark}</td>
              <td className="text-right">
                <div className="text-xs opacity-70">
                  {i.currency}{" "}
                  {i.amount_in_currency.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </div>
                <div>
                  {i.amount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  {currencySymbol}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RecurringItemsView;
